import React from 'react'
import { graphql } from 'gatsby'

import TeaserTemplate from '../templates/Teaser'

export const IndexPage: React.FC<{
    data?: object
    location?: object
}> = ({ data, location }) => {
    return <TeaserTemplate location={location} data={data} />
}

export const query = graphql`
    {
        contentfulTeaser(
            node_locale: { eq: "de" }
            property: { name: { regex: "/pazola/i" } }
        ) {
            copy {
                childMarkdownRemark {
                    html
                }
            }
            title
            metaInformation {
                pageTitle
                pageImage {
                    fluid {
                        src
                    }
                }
                description {
                    childMarkdownRemark {
                        html
                    }
                }
            }
            visionTitle
            visionCopy {
                childMarkdownRemark {
                    html
                }
            }
            visionImage {
                desktopImage {
                    fluid(quality: 90, maxWidth: 1680) {
                        srcWebp
                        srcSetWebp
                        ...GatsbyContentfulFluid
                    }
                }
                mobileImage {
                    fluid(quality: 90, maxWidth: 750) {
                        srcWebp
                        srcSetWebp
                        ...GatsbyContentfulFluid
                    }
                }
            }
            visionButton {
                text
                buttonLink {
                    ... on ContentfulLink {
                        internalFile {
                            file {
                                url
                                contentType
                            }
                            title
                        }
                        externalLink
                    }
                }
            }
            contentBlocks {
                alignment
                title
                theme
                copy {
                    childMarkdownRemark {
                        html
                    }
                }
            }
        }
    }
`

export default IndexPage
